import { Subject } from "rxjs";
import { apiServiceConstants } from "../../../../../constants/apiService.constants";
import { apiService } from "../../../../../services/apiService";
import { utilService } from "../../../../../services/utilService";

let contactNumData: any = [];
let showContactNumAlert = new Subject<any>();
let contactDetailsUpdated = new Subject<any>();
let timeOutData: any = [];

const updateTime = (time: any) => {
  const currentTime = time.split(":");
  return currentTime[0] + ":" + currentTime[1];
};

const formatTimeInSeconds = (time: any) => {
  var array = time?.split(":");
  var timeInSeconds =
    parseInt(array[0], 10) * 60 * 60 + parseInt(array[1], 10) * 60 + 0;

  return timeInSeconds;
};

// To show the reminder alerts
const getContactNumAlerts = (contactNumData: any) => {
  if (!utilService.isEmpty(contactNumData)) {
    const getTime = new Date().toTimeString();
    const formatTime = getTime.slice(0, 8);
    const currentTime = formatTime.split(":");
    const getTimeInputData = currentTime[0] + ":" + currentTime[1];

    const contactNumTime: any = updateTime(
      utilService.getTimeOnly(contactNumData.time)
    );
    const contactNum = formatTimeInSeconds(contactNumTime);
    const currentTimeValue = formatTimeInSeconds(getTimeInputData);
    const timeDifference = contactNum - currentTimeValue;
    if (timeDifference < 0) {
      showContactNumAlertWithTimeDifference(1, contactNumData);
    } else {
      let formattedTimeDifference =
        timeDifference < 0 ? 86400 - timeDifference * -1 : timeDifference;
      showContactNumAlertWithTimeDifference(
        formattedTimeDifference,
        contactNumData
      );
    }
  }
};

async function fetchContactTimerInfo(params: any) {
  const respTimerInfo: any = await getContactTimerInformation(params);
  if (respTimerInfo.isSuccess) {
    if (respTimerInfo.result) {
      utilService.phoneReminderData = respTimerInfo.result;
      ContactNumAlertService.getContactNumAlerts(utilService.phoneReminderData);
    }
  } else {
    console.log("error");
  }
}

const getContactTimerInformation = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `user/timer-list/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const contactTimerResp = res as any;
      var DoctorInformationResponse: any;
      if (contactTimerResp.result) {
        DoctorInformationResponse = setTimerInfo(
          contactTimerResp.result?.[0]?.data[0]
        );
      }
      const result: any = {
        isSuccess: true,
        result: DoctorInformationResponse,
        status: contactTimerResp.status,
        message: contactTimerResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setTimerInfo = (data: any) => {
  const timerData = {
    note: data.note,
    time: utilService.getDate(data.time),
  };
  return timerData;
};

const contactDetailsUpdate = (list: any) => {
  contactDetailsUpdated.next(list);
};

const showContactNumAlertWithTimeDifference = (
  formattedTimeDifference: any,
  element: any
) => {
  timeOutData = setTimeout(() => {
    if (formattedTimeDifference !== 0) {
      showContactNumAlert.next(element);
    }
  }, formattedTimeDifference * 1000);
};

const clearTimeOutData = () => {
  clearTimeout(timeOutData);
};

export const ContactNumAlertService = {
  getContactNumAlerts,
  showContactNumAlert,
  contactNumData,
  contactDetailsUpdate,
  fetchContactTimerInfo,
  contactDetailsUpdated,
  clearTimeOutData,
  getContactTimerInformation,
};
